import React, { useEffect, useState } from 'react'
import { Input } from 'antd'
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'

const ProposalAdvanceInputFilter = props => {
  const { proposalAdvanceStore } = props
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)
  const [isChangeInput, setIsChangeInput] = useState(false)
  const [inputValue, setInputValue] = useState(queryStringParse.keyword)
  const [isInputting, setIsInputting] = useState(false)

  useEffect(() => {
    if (!isChangeInput) return
    setIsInputting(true)
    const delayFilter = setTimeout(() => {
      proposalAdvanceStore.setQueryParams('filterPage', 0)
      proposalAdvanceStore.setQueryParams('filterKeyword', inputValue)
      setIsInputting(false)
    }, 500)
    return () => {
      clearTimeout(delayFilter)
    }
  }, [inputValue])

  const onchangeInput = e => {
    setInputValue(e.target.value)
    setIsChangeInput(true)
  }

  return (
    <Input.Search
      size="large"
      className="rounded-search"
      value={inputValue}
      style={{ width: 300 }}
      allowClear
      onChange={onchangeInput}
      placeholder={'Tìm kiếm trình tạm ứng...'}
    />
  )
}

ProposalAdvanceInputFilter.propTypes = {}

export default inject('proposalAdvanceStore')(
  observer(ProposalAdvanceInputFilter)
)
